__turbopack_export_value__({
  "body-logo-18": "News-module-scss-module__hIkBAq__body-logo-18",
  "body-text-12": "News-module-scss-module__hIkBAq__body-text-12",
  "body-text-14": "News-module-scss-module__hIkBAq__body-text-14",
  "body-text-16": "News-module-scss-module__hIkBAq__body-text-16",
  "body-text-18": "News-module-scss-module__hIkBAq__body-text-18",
  "body-text-20": "News-module-scss-module__hIkBAq__body-text-20",
  "body-text-24": "News-module-scss-module__hIkBAq__body-text-24",
  "body-text-24-2": "News-module-scss-module__hIkBAq__body-text-24-2",
  "body-text-heading-2": "News-module-scss-module__hIkBAq__body-text-heading-2",
  "body-text-heading-3": "News-module-scss-module__hIkBAq__body-text-heading-3",
  "body-text-medium-14": "News-module-scss-module__hIkBAq__body-text-medium-14",
  "body-text-medium-16": "News-module-scss-module__hIkBAq__body-text-medium-16",
  "body-text-medium-18": "News-module-scss-module__hIkBAq__body-text-medium-18",
  "body-text-medium2-18": "News-module-scss-module__hIkBAq__body-text-medium2-18",
  "body-text2-14": "News-module-scss-module__hIkBAq__body-text2-14",
  "body-text2-16": "News-module-scss-module__hIkBAq__body-text2-16",
  "button-primary-text": "News-module-scss-module__hIkBAq__button-primary-text",
  "button-text": "News-module-scss-module__hIkBAq__button-text",
  "button2-text": "News-module-scss-module__hIkBAq__button2-text",
  "card-shadow": "News-module-scss-module__hIkBAq__card-shadow",
  "effect-menu": "News-module-scss-module__hIkBAq__effect-menu",
  "header-1": "News-module-scss-module__hIkBAq__header-1",
  "main-container": "News-module-scss-module__hIkBAq__main-container",
  "main-footer-container": "News-module-scss-module__hIkBAq__main-footer-container",
  "main-header-container": "News-module-scss-module__hIkBAq__main-header-container",
  "news": "News-module-scss-module__hIkBAq__news",
  "news__list": "News-module-scss-module__hIkBAq__news__list",
  "news__showMore": "News-module-scss-module__hIkBAq__news__showMore",
  "txt-12-bold": "News-module-scss-module__hIkBAq__txt-12-bold",
  "txt-14-bold": "News-module-scss-module__hIkBAq__txt-14-bold",
  "txt-14-bold-caps": "News-module-scss-module__hIkBAq__txt-14-bold-caps",
  "txt-14-med": "News-module-scss-module__hIkBAq__txt-14-med",
  "txt-16-bold": "News-module-scss-module__hIkBAq__txt-16-bold",
  "txt-16-med": "News-module-scss-module__hIkBAq__txt-16-med",
  "txt-18-bold": "News-module-scss-module__hIkBAq__txt-18-bold",
  "txt-18-medium": "News-module-scss-module__hIkBAq__txt-18-medium",
  "txt-18-medium-24": "News-module-scss-module__hIkBAq__txt-18-medium-24",
  "txt-24-semi": "News-module-scss-module__hIkBAq__txt-24-semi",
});
